import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import jobAppSlice from "./slices/jobAppSlice";
import documentsSlice from "./slices/documentsSlice";
import masterDataSlice from "./slices/masterDataSlice";


export const store = configureStore({
    reducer:{
        user: userSlice.reducer,
        jobapp: jobAppSlice.reducer,
        documentDMS:documentsSlice.reducer,
        masterData: masterDataSlice.reducer,
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch